var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAngry(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.19 28.38C22.9224 28.38 28.38 22.9224 28.38 16.19C28.38 9.45764 22.9224 4 16.19 4C9.45764 4 4 9.45764 4 16.19C4 22.9224 9.45764 28.38 16.19 28.38Z",
    fill: "url(#paint0_radial_179_9058)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M16.19 28.38C22.9224 28.38 28.38 22.9224 28.38 16.19C28.38 9.45764 22.9224 4 16.19 4C9.45764 4 4 9.45764 4 16.19C4 22.9224 9.45764 28.38 16.19 28.38Z",
    fill: "url(#paint1_radial_179_9058)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9573 21.1455C15.9573 21.1455 18.486 21.1342 19.3535 23.1469C19.4102 23.2717 19.4442 23.4077 19.4555 23.5495C19.4782 23.8273 19.2854 24.1165 18.7978 23.9294C18.0268 23.6289 16.7057 23.4701 15.9573 23.4701C15.2146 23.4701 13.8878 23.6232 13.1167 23.9294C12.6348 24.1165 12.442 23.8273 12.459 23.5495C12.4704 23.4077 12.5044 23.2717 12.5611 23.1469C13.4286 21.1399 15.9573 21.1455 15.9573 21.1455Z",
    fill: "url(#paint2_radial_179_9058)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2098 19.2802C12.8579 19.2802 13.3834 18.4857 13.3834 17.5056C13.3834 16.5255 12.8579 15.731 12.2098 15.731C11.5616 15.731 11.0361 16.5255 11.0361 17.5056C11.0361 18.4857 11.5616 19.2802 12.2098 19.2802Z",
    fill: "url(#paint3_radial_179_9058)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7448 16.8706C12.4309 16.8706 13.0035 17.5736 13.1679 18.5262C13.304 18.237 13.3834 17.8855 13.3834 17.5056C13.3834 16.5247 12.8561 15.731 12.2097 15.731C11.6484 15.731 11.1779 16.3263 11.0645 17.1257C11.2686 16.9613 11.501 16.8706 11.7448 16.8706Z",
    fill: "url(#paint4_linear_179_9058)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9566 13.1851C9.90764 13.1851 9.00616 14.3927 10.1798 14.5798C11.3534 14.7669 13.491 15.7761 14.3924 16.4735C14.4605 16.5529 14.727 16.5302 14.71 16.3204C14.7043 15.521 12.2323 13.1851 10.9566 13.1851Z",
    fill: "url(#paint5_linear_179_9058)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9575 21.8086C15.9575 21.8086 18.0156 21.8029 19.4217 23.3848C19.4047 23.3054 19.382 23.226 19.348 23.1523C18.4805 21.1396 15.9518 21.1509 15.9518 21.1509C15.9518 21.1509 13.4231 21.1396 12.5556 23.1523C12.5216 23.226 12.4989 23.3054 12.4819 23.3848C13.8937 21.8029 15.9575 21.8086 15.9575 21.8086Z",
    fill: "url(#paint6_linear_179_9058)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.17 19.2802C20.8182 19.2802 21.3436 18.4857 21.3436 17.5056C21.3436 16.5255 20.8182 15.731 20.17 15.731C19.5218 15.731 18.9963 16.5255 18.9963 17.5056C18.9963 18.4857 19.5218 19.2802 20.17 19.2802Z",
    fill: "url(#paint7_radial_179_9058)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6349 16.8706C19.9489 16.8706 19.3762 17.5736 19.2118 18.5262C19.0757 18.237 18.9963 17.8855 18.9963 17.5056C18.9963 16.5247 19.5237 15.731 20.17 15.731C20.7313 15.731 21.2019 16.3263 21.3153 17.1257C21.1112 16.9613 20.8787 16.8706 20.6349 16.8706Z",
    fill: "url(#paint8_linear_179_9058)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4231 13.1851C22.472 13.1851 23.3735 14.3927 22.1999 14.5798C21.0262 14.7669 18.8887 15.7761 17.9872 16.4735C17.9192 16.5529 17.6527 16.5302 17.6697 16.3204C17.6754 15.521 20.1474 13.1851 21.4231 13.1851Z",
    fill: "url(#paint9_linear_179_9058)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_179_9058",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.7916 11.2498) scale(14.7056)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAC30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D2E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_179_9058",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.7916 11.2498) scale(11.5696)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB47",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_179_9058",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.9549 22.5684) scale(2.66909 1.42183)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_179_9058",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.8539 17.5485) rotate(73.8539) scale(1.72236 1.11434)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_179_9058",
    x1: 12.2239,
    y1: 16.2711,
    x2: 12.2239,
    y2: 17.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_179_9058",
    x1: 12.1648,
    y1: 17.4029,
    x2: 12.1648,
    y2: 13.7201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_179_9058",
    x1: 15.9551,
    y1: 20.276,
    x2: 15.9551,
    y2: 22.1951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_179_9058",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.5481 17.5296) rotate(106.146) scale(1.72236 1.11434)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_179_9058",
    x1: 20.1559,
    y1: 16.2711,
    x2: 20.1559,
    y2: 17.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_179_9058",
    x1: 20.2148,
    y1: 17.4029,
    x2: 20.2148,
    y2: 13.7201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngry);
export default __webpack_public_path__ + "static/media/angry.c00a08d9418139e88450584a97b4fce3.svg";
export { ForwardRef as ReactComponent };